import axiosInstance from './apiinterseptor';

export interface RecruiterRequestRow {
  _id: string;
  updatedDateTime?: string;
  approvalStatus?: 'PENDING' | 'APPROVED' | 'DENIED';
  reviewedAt?: string;
  rejectionReason?: string;
  linkedUserId?: string;
  hiringDept?: string[];
  personalDetails?: {
    fullName?: string;
    email?: string;
    phone?: string;
    recruiterType?: string;
    applyFor?: string;
    wtspNum?: string;
    gender?: string;
    dob?: string;
    role?: string;
    currCity?: string | null;
    currState?: string | null;
    permCity?: string;
    permState?: string;
    languages?: string[];
  };
  qualification?: {
    highestQualification?: string;
    workExperience?: Array<{
      CompanyName?: string;
      ExperienceYears?: string;
    }>;
  };
  about?: {
    questions?: Array<{
      question?: string;
      answer?: string | string[];
    }>;
  };
  familyMembers?: Record<string, unknown>;
  references?: Record<string, unknown>;
  newIdentityProof?: {
    photo?: string;
    aadharFront?: string;
    aadharBack?: string;
    panFront?: string;
    panBack?: string;
  };
}

export interface RecruiterRequestsAdminResponse {
  data: RecruiterRequestRow[];
  pagination: {
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
  };
}

export const getRecruiterRequestsAdmin = async (
  page: number = 1,
  limit: number = 20,
  status: 'PENDING' | 'APPROVED' | 'DENIED' | 'ALL' = 'PENDING'
): Promise<RecruiterRequestsAdminResponse> => {
  const response = await axiosInstance.get('/recruiter/admin', { params: { page, limit, status } });
  return {
    data: response.data?.data ?? [],
    pagination: response.data?.pagination ?? {
      page,
      limit,
      totalPages: 1,
      totalResults: 0,
    },
  };
};

export const approveRecruiterRequestAdmin = async (recruiterRequestId: string, linkedUserId?: string) => {
  const response = await axiosInstance.patch(`/recruiter/admin/${recruiterRequestId}/approve`, {
    linkedUserId,
  });
  return response.data;
};

export const denyRecruiterRequestAdmin = async (recruiterRequestId: string, reason?: string) => {
  const response = await axiosInstance.patch(`/recruiter/admin/${recruiterRequestId}/deny`, {
    reason: reason || '',
  });
  return response.data;
};
